import React from 'react';
import PropTypes from 'prop-types';

import './styles.css';
import Profile from './Profile';

class ProfilesMenu extends React.PureComponent {
  static propTypes = {
    profile: PropTypes.shape({
      custom_profiles: PropTypes.array,
    }),
    collegeName: PropTypes.string,
  };

  render() {
    const { collegeName } = this.props;
    const profile = this.props.profile || {};
    return (
      <div className="profile-menu-container common-full-width">
        {[]
          .concat(profile.custom_profiles || [])
          .map((cp, index) =>
            cp && cp.type === 'student' ? (
              <Profile
                key={`${cp.persons_name}-${index}`}
                profile={cp}
                showHeading={index === 0}
                collegeName={collegeName}
              />
            ) : null,
          )}
      </div>
    );
  }
}

export default ProfilesMenu;
